import { DetailsSubHeader } from "../../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { type RootState } from "../../../../Application/globaltypes/redux";
import { connect } from "react-redux";

export type EmailDetailsSubheaderContainerProps = DetailsSubHeaderProps & {
  showLastModified: boolean;
};

const mapStateToProps = (state: RootState, ownProps: EmailDetailsSubheaderContainerProps) => ({
  isUpdateInProgress:
    state.library.emails.emailEntityStateReducer.isEntityCommandInProgress && ownProps.isUpdateInProgress,
  lastModifiedDateTime: ownProps.showLastModified
    ? state.library.emails.emailEntityStateReducer.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
    : undefined,
});

export default connect(mapStateToProps)(DetailsSubHeader);
